export function getTeamSupportWidgetSnippet() {
  var se = document.createElement("script");
  se.type = "text/javascript";
  se.async = true;

  se.src =
    "https://storage.googleapis.com/code.snapengage.com/js/44b44f77-65a6-4c09-b5ae-88feb23a4442.js";

  var done = false;

  se.onload = se.onreadystatechange = function () {
    if (
      !done &&
      (!this.readyState ||
        this.readyState === "loaded" ||
        this.readyState === "complete")
    ) {
      done = true;

      /* Place your SnapEngage JS API code below */

      /* SnapEngage.allowChatSound(true); Example JS API: Enable sounds for Visitors. */
    }
  };

  var s = document.getElementsByTagName("script")[0];
  s.parentNode.insertBefore(se, s);
}
